export const getSurgeonSurname = (surgeonName: string): string => {
  const normalizedName = surgeonName
    .replace(/^dr\.?\s+/i, '')
    .trim();
  const nameParts = normalizedName.split(/\s+/).filter(Boolean);

  return nameParts.at(-1) ?? surgeonName;
};
